import { apiClient } from '@/lib/apiClient';

export interface SystemHealthData {
  status: string;
  timestamp: string;
  system: {
    cpu_usage: string;
    memory_usage: string;
    disk_usage: string;
    process_memory: string;
  };
  services: {
    database: string;
    redis: string;
    llm: {
      groq: {
        status: string;
        details: {
          url: string;
        };
      };
    };
  };
  version: string;
}

class SystemHealthService {
  async getSystemHealth(): Promise<SystemHealthData> {
    return apiClient.get<SystemHealthData>('/health/');
  }

  // Helper to parse usage percentage
  parseUsagePercentage(usage: string): number {
    return parseFloat(usage.replace('%', ''));
  }

  // Helper to get status color based on percentage
  getUsageColor(percentage: number, thresholds = { warning: 70, critical: 85 }): 'success' | 'warning' | 'destructive' {
    if (percentage >= thresholds.critical) return 'destructive';
    if (percentage >= thresholds.warning) return 'warning';
    return 'success';
  }
}

export const systemHealthService = new SystemHealthService();
